const getters = {
  getTeamByID: (state) => (id) => {
    if (id === undefined) {
      return {}
    }
    const team = state.inspector_teams.data.find(team => team.id === id)
    if (!team) {
      return {}
    }
    return team
  }
}

export default getters
